import { Box, Text } from "@chakra-ui/react";
import ProgressBar from "../../../ProgressBar";
import { getActivityAnswers } from "@utils/helpers";

const PollResults = ({ title, options, response }) => {
  const filterAnswerCallback = (response, option) =>
    response.responseIds.includes(option._id);
  const responseArray = getActivityAnswers(
    options,
    response,
    filterAnswerCallback,
    response.length
  );

  return (
    <>
      <Text fontWeight="600" fontSize="12px" color="dark.400" mb="1">
        {title}
      </Text>
      {responseArray.map((res, index) => (
        <Box mb={1} key={res.id}>
          <Text fontWeight="400" fontSize="12px" color="dark.400" mb="1">
            {res.label}
          </Text>
          <ProgressBar key={res.id} value={res.value} color="gray.300" />
        </Box>
      ))}
    </>
  );
};

export default PollResults;
